import React, { useState, useEffect } from 'react';
import OutputType from './ComponentsTpes/OutputType';

const ExitRelay = ({ selectedType, fieldsData, componentSourceOptions, selectedPorts, setSelectedPorts,
    savedData, setSavedData
}) => {
    const selectOptions = (key, value) => {
        setSavedData(prevData => {
            return {
                ...prevData,
                Exit_relay: {
                    ...prevData.Exit_relay,
                    [key]: value
                }
            }
        })
    }

    return <OutputType
        selectedPorts={selectedPorts}
        setSelectedPorts={setSelectedPorts}
        source={componentSourceOptions.outputsData}
        selectOptions={selectOptions}
        component_source={savedData.Exit_relay.component_source.value}
        condition={savedData.Exit_relay.condition}
        output={savedData.Exit_relay.output}
        name={savedData.Exit_relay.name}
        relay_mode={savedData.Exit_relay.relay_mode}
        impulse_time={savedData.Exit_relay.impulse_time}
        entry_exit_open_durations={savedData.Exit_relay.entry_exit_open_durations}
        sensorAutolock={savedData.Exit_relay.sensorAutolock}
        fieldsData={fieldsData}
    />
}

export default ExitRelay;